module.exports = __webpack_public_path__ + "static/media/lr.fca70dfe.svg";